export enum QuoteEventType {
  DeliveryEmailSent = 'delivery.email.sent',
  DeliveryManualSent = 'delivery.manual.sent',
  DocumentAccepted = 'document.accepted',
  DocumentCreated = 'document.created',
  DocumentDeleted = 'document.deleted',
  DocumentEdited = 'document.edited',
  DocumentInvoiced = 'document.invoiced',
  DocumentPdfDownloaded = 'document.pdf.downloaded',
  DocumentRejected = 'document.rejected',
  DocumentSent = 'document.manual.sent',
  DocumentUnaccepted = 'document.unaccepted',
  DocumentUnrejected = 'document.unrejected',
  DocumentUnsent = 'document.unsent',
}
